export class PT {
    getTranslations() {
        return {
            btn_validate: 'Confirmar',
            btn_cancel: 'Cancelar',
            btn_close: 'Fechar',
            btn_add: 'Adicionar',
            btn_delete: 'Apagar',
            msg_alert: 'Alerta',
            msg_success: 'Successo',
            msg_confirm: 'Confirme',
            msg_input: 'Entrada',
            datahub_pickup_indicator: 'Escolher indicadores',
            datahub_fields: 'Campos',
            config_menu_loading: 'A carregar menu...',
            editable_label_edit: 'Editar',
            editable_label_validate: 'Validar',
            please_wait: 'Aguarde...',
            combobox_placeholder: 'Selecione uma opção',
            card_button_start: 'Iniciar',
            enter_credentials_to: 'Introduza as suas credenciais para aceder a ',
        };
    }
}
